/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { AuditLog, GetAuditLogParams } from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary Find
 */
export const getAuditLog = (
  params?: GetAuditLogParams,
  signal?: AbortSignal,
) => {
  return customInstance<AuditLog[]>({
    url: `/audit-log`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAuditLogInfiniteQueryKey = (params?: GetAuditLogParams) => {
  return ["infinite", `/audit-log`, ...(params ? [params] : [])] as const;
};

export const getGetAuditLogQueryKey = (params?: GetAuditLogParams) => {
  return [`/audit-log`, ...(params ? [params] : [])] as const;
};

export const getGetAuditLogInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getAuditLog>>>,
  TError = void,
>(
  params?: GetAuditLogParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAuditLog>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAuditLogInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuditLog>>> = ({
    signal,
  }) => getAuditLog(params, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getAuditLog>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAuditLogInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAuditLog>>
>;
export type GetAuditLogInfiniteQueryError = void;

export function useGetAuditLogInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAuditLog>>>,
  TError = void,
>(
  params: undefined | GetAuditLogParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAuditLog>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuditLog>>,
          TError,
          Awaited<ReturnType<typeof getAuditLog>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAuditLogInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAuditLog>>>,
  TError = void,
>(
  params?: GetAuditLogParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAuditLog>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuditLog>>,
          TError,
          Awaited<ReturnType<typeof getAuditLog>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAuditLogInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAuditLog>>>,
  TError = void,
>(
  params?: GetAuditLogParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAuditLog>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find
 */

export function useGetAuditLogInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getAuditLog>>>,
  TError = void,
>(
  params?: GetAuditLogParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getAuditLog>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAuditLogInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAuditLogQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuditLog>>,
  TError = void,
>(
  params?: GetAuditLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuditLog>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAuditLogQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuditLog>>> = ({
    signal,
  }) => getAuditLog(params, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAuditLog>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAuditLogQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAuditLog>>
>;
export type GetAuditLogQueryError = void;

export function useGetAuditLog<
  TData = Awaited<ReturnType<typeof getAuditLog>>,
  TError = void,
>(
  params: undefined | GetAuditLogParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuditLog>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuditLog>>,
          TError,
          Awaited<ReturnType<typeof getAuditLog>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAuditLog<
  TData = Awaited<ReturnType<typeof getAuditLog>>,
  TError = void,
>(
  params?: GetAuditLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuditLog>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuditLog>>,
          TError,
          Awaited<ReturnType<typeof getAuditLog>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAuditLog<
  TData = Awaited<ReturnType<typeof getAuditLog>>,
  TError = void,
>(
  params?: GetAuditLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuditLog>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find
 */

export function useGetAuditLog<
  TData = Awaited<ReturnType<typeof getAuditLog>>,
  TError = void,
>(
  params?: GetAuditLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAuditLog>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAuditLogQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
